angular
  .module('app')
  .controller('DashMainController', DashMainController);

DashMainController.$inject = ['Session', 'Summary', 'Film', '$rootScope'];

function DashMainController(Session, Summary, Film, $rootScope) {
  var vm = this;
  $rootScope.loading = true;

  if (!Session.id) {
    Session.go('main.index');
  }

  var info = Summary.get({id: Session.id}).$promise;
  info.then(function (res) {
    $rootScope.loading = false;
    vm.info = res;
  });

  vm.addfilm = function (section) {
    $rootScope.loading = true;
    var film = Film.save({id: Session.id, cat: section}).$promise;
    film.then(function () {
      $rootScope.loading = false;
      Session.reload();
    });
  };
}
